module.exports = __webpack_public_path__ + "img/parents-1-2.8874645c.jpg";